import React from 'react';
import { connect } from 'react-redux';
import { ButtonV2, RenderField } from '@zola/zola-ui';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import * as Validations from 'components/common/form/commonValidations';
import { editOtherRegistryUrl } from 'actions/RegistryBulkImportActions';
import { hideModal } from 'actions/ModalActions';
import LinkIcon from 'assets/images/registry/importRegistryAccountPage/link.svg';

import './EditRegistryModal.less';

const EditOtherRegistryModal = ({
  retailerName,
  handleEditOtherRegistry,
  closeModal,
  registryUrl,
  retailerDomain,
  registryId,
  valid,
  urlValue,
  submitUrlError,
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    handleEditOtherRegistry(retailerDomain, urlValue, registryId, retailerName);
  };

  return (
    <div className="other-registries__edit-modal">
      <h2 className="other-registries__edit-modal__header">Update {retailerName} Registry URL</h2>
      <form onSubmit={handleSubmit} className="other-registries__edit-modal__form">
        <p>
          Changed your other registry’s URL? Enter the new URL below, so we can keep syncing your{' '}
          {retailerName} registry.
        </p>
        <img className="other-registries__edit-modal__input__icon" src={LinkIcon} alt="Checklist" />
        <Field
          id="other-registries__edit-modal__input"
          placeholder={registryUrl}
          name="url"
          type="text"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.URL]}
          className="other-registries__edit-modal__input"
        />
        {submitUrlError && !Validations.REQUIRED(urlValue) && !Validations.URL(urlValue) && (
          <div className="other-registries__edit-modal__error-block">
            Oops! Make sure you’ve entered your registry’s correct URL (including the “https://” or
            “http://”).
          </div>
        )}
        <div className="other-registries__edit-modal_ctas">
          <ButtonV2 variant="secondary" onClick={closeModal}>
            Cancel
          </ButtonV2>
          <ButtonV2 value="import" type="submit" disabled={!valid}>
            Save
          </ButtonV2>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  urlValue: formValueSelector('registryImportUrlForm')(state, 'url'),
  submitUrlError: state.registryBulkImport.submitUrlError,
  initialValues: { url: ownProps.registryUrl },
});

const mapDispatchToProps = dispatch => ({
  handleEditOtherRegistry: (retailerDomain, registryUrl, registryId, retailerName) =>
    dispatch(editOtherRegistryUrl(retailerDomain, registryUrl, registryId, retailerName)),
  closeModal: () => dispatch(hideModal()),
});

const RegistryImportUrlForm = reduxForm({
  form: 'registryImportUrlForm',
  destroyOnUnmount: true,
})(EditOtherRegistryModal);

export default connect(mapStateToProps, mapDispatchToProps)(RegistryImportUrlForm);



// WEBPACK FOOTER //
// ./src/pages/settings/otherRegistries/components/EditRegistryModal.jsx